import { AssetsFilter } from '../models';
import { useGetAssetsQuery } from '../service';

interface UseAssetProps {
  filters?: AssetsFilter;
  page: number;
  pageSize: number;
  search?: string;
}

const useAssets = ({ filters, page, pageSize, search }: UseAssetProps) => {
  const {
    data: assets,
    isLoading: isAssetsLoading,
    error,
  } = useGetAssetsQuery({ filters, paginated: { page, pageSize }, search });

  return {
    assets: assets?.items || [],
    totalItems: assets?.count || [].length,
    totalPages: assets?.count ? Math.ceil(assets.count / pageSize) : 0,
    isAssetsLoading,
    error,
  };
};

export default useAssets;
